export default __webpack_public_path__ + "static/media/11.f770827f.png";